import { MainPage } from './pages/MainPage/MainPage'
import { Header } from './components/Header/Header'
import { Footer } from './components/Footer/Footer'

function App() {

  return (
    <>
      <Header />
      <main className="main">
        <MainPage />
      </main>
      <Footer />
    </>
  )
}

export default App
